import { render, staticRenderFns } from "./popover-list.component.vue?vue&type=template&id=ee1d4584&scoped=true"
import script from "./popover-list.component.vue?vue&type=script&lang=ts"
export * from "./popover-list.component.vue?vue&type=script&lang=ts"
import style0 from "./popover-list.component.vue?vue&type=style&index=0&id=ee1d4584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1d4584",
  null
  
)

export default component.exports